// extracted by mini-css-extract-plugin
export default {"adContainer":"ZwBWE","ad":"Z40w9","adBelowText":"i7fcS","icon":"zBfpo"};